import React from "react";
import { textFilter } from "react-bootstrap-table2-filter";
import CommonUtil from "../../../../utils/CommonUtil";
import FilteringComponent from "../FilteringComponent";

class TableComponent extends FilteringComponent {
  constructor(props) {
    super(props);

    this.shouldResetFilters = false;

    this._filters = {};
  }

  initColumns(columns) {
    for (var i = 0; i < columns.length; i++) {
      if (columns[i].filter) {
        const filter = columns[i].filter;
        columns[i].filter = this.createFilter(filter, columns[i].dataField);
      }
    }
    return columns;
  }

  createFilter = (filterSettings, dataField) => {
    switch (filterSettings.type) {
      case "text":
        var filterProps = {
          placeholder: filterSettings.placeholder,
          className: filterSettings.className,
          delay: filterSettings.delay
        };
        if (filterSettings.comparator) {
          filterProps.comparator = filterSettings.comparator;
        }
        return textFilter({
          ...filterProps,
          getFilter: filter => {
            this._filters[dataField + "Filter"] = {
              filter: filter,
              type: filterSettings.type
            };
          }
        });
      default:
        break;
    }

    return undefined;
  };

  initialState() {
    return {
      ...super.initialState(),
      links: undefined,
      selectOptions: undefined
    };
  }

  initialPageSize() {
    return 10;
  }

  onDataLoad = data => {
    let pageInfo = data.page;
    pageInfo.filters = this.state.pageInfo.filters;
    this.setState({
      content: data._embedded ? data._embedded.content : [],
      pageInfo: pageInfo,
      links: data._links,
      isLoading: false
    });
  };

  resetComponent() {
    this.state = this.initialState();
    this.sortInfo = this.initialSortInfo();
    this.resetFilters();
  }

  resetFilters() {
    const filters = this._filters;
    Object.keys(filters).forEach(function (key, _) {
      var filterVal = undefined;
      switch (filters[key].type) {
        case "text":
          filterVal = "";
          break;
        default:
          break;
      }
      filters[key].filter(filterVal);
    });
  }

  loadData = pageInfo => {
    throw new Error("You have to implement the method loadData!");
  };

  startLoading = (pageInfo, sortInfo) => {
    this.removeAdvancedSearchParamsFromFilter(pageInfo);
    const links = undefined;
    this.setState({
      isLoading: true,
      pageInfo: pageInfo,
      links: links
    });
    this.sortInfo = sortInfo;
    this.loadData(pageInfo);
  };

  removeAdvancedSearchParamsFromFilter = pageInfo => {
    const { advancedSearchParams } = this.state;
    if (advancedSearchParams) {
      var filters = pageInfo.filters;
      Object.keys(advancedSearchParams).forEach(function (key) {
        if (filters && filters[key]) {
          delete filters[key];
        }
      });
      this.state.pageInfo.filters = filters;
    }
  };

  onFilteringChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder }
  ) => {
    const pageInfo = {
      number: page - 1,
      size: sizePerPage,
      filters: this._rectifyFilters(filters)
    };

    const sortInfo = this._resetInProgress
      ? this.sortInfo
      : {
          orderBy: sortField,
          direction: sortOrder
        };

    if (!this._resetInProgress && this._isMounted) {
      this.startLoading(pageInfo, sortInfo);
    }
  };

  _rectifyFilters = filters => {
    if (filters && this.columns) {
      this.columns.forEach(column => {
        if (column.hasOwnProperty("filterName")) {
          column = CommonUtil.renameProperty(
            filters,
            column.dataField,
            column.filterName
          );
        }
      });
      filters.active = this.state.pageInfo.filters.active;
    }
    return filters;
  };

  constructPaginationOptions() {
    return {
      page: this.state.pageInfo.number + 1,
      sizePerPage: this.state.pageInfo.size,
      totalSize: this.state.pageInfo.totalElements,
      sizePerPageList: this.possibleSizesPerPage()
    };
  }
  possibleSizesPerPage() {
    return [5, 10, 15, 20];
  }

  formatHeader = (column, colIndex, { sortElement, filterElement }) => {
    return (
      <>
        <div>
          {column.text}
          {sortElement}
        </div>
        <div className="table-filter">{filterElement}</div>
      </>
    );
  };

  renderProps() {
    return {
      ...super.renderProps(),
      columns: this.columns,
      paginationOptions: this.constructPaginationOptions(),
      onTableChange: this.onFilteringChange
    };
  }
}

export default TableComponent;
